import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unloading_platform_management",
  "use": "icon-unloading_platform_management-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-unloading_platform_management\"><path d=\"M927 607.8H704v-268c0-28.6-28.8-52-64-52H384c-35.2 0-64 23.4-64 52v268H97c-0.5 0-1 0.5-1 1v94c0 0.5 0.5 1 1 1h830c0.5 0 1-0.5 1-1v-94c0-0.6-0.5-1-1-1z m-543-256h256v256H384v-256zM817.1 735.8H206.9c-25.8 0-46.9 20.9-46.9 46.5v162.9c0 25.6 21.1 46.5 46.9 46.5H817c25.8 0 46.9-20.9 46.9-46.5V782.3c0.1-25.6-21-46.5-46.8-46.5z m-17.1 192H215.5v-128H800v128zM480 223.8h64c35.2 0 64-28.8 64-64v-64c0-35.2-28.8-64-64-64h-64c-35.2 0-64 28.8-64 64v64c0 35.2 28.8 64 64 64z m0-128h64v64h-64v-64z\" fill=\"#ffffff\" p-id=\"10988\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/unloading_platform_management.svg
// module id = O4Uj
// module chunks = 39